import { FormEvent, useEffect, useState } from "react";

import { updateWorkflowCategories } from "@/api/category";
import { createWorkflow, editWorkflow } from "@/api/workflow";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useWorkflowModalStore } from "@/hooks/store/use-workflow-modal-store";

import CategoryMultiSelect from "../category-multi-select";

import { getCategoryIds } from "@/utils/category";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import Modal from "@/components/ui/modal";
import { Textarea } from "@/components/ui/textarea";

const WorkflowModal = () => {
  const queryClient = useQueryClient();

  const { isOpen, onClose, workflow } = useWorkflowModalStore();
  const [selectedCategoryIds, setSelectedCategoryIds] = useState<number[]>(
    () => getCategoryIds(workflow)
  );

  useEffect(() => {
    setSelectedCategoryIds(getCategoryIds(workflow));
  }, [workflow, isOpen]);

  const { mutate, isPending } = useMutation({
    mutationFn: async (data: any) => {
      const response = workflow
        ? await editWorkflow(workflow.id, data)
        : await createWorkflow(data);
      const targetId = workflow?.id ?? response?.data?.id;

      if (targetId && selectedCategoryIds.length) {
        await updateWorkflowCategories(targetId, selectedCategoryIds);
      }

      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["workflows"] });
      onClose();
    }
  });

  const titleText = workflow
    ? `ویرایش گردش کار ${workflow.name}`
    : "ساخت گردش کار جدید";
  const submitBtnText = workflow ? "ویرایش گردش کار" : "ساخت گردش کار جدید";

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);

    const newData = Object.fromEntries(formData);

    mutate(newData);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} description="" title={titleText}>
      <form onSubmit={handleSubmit} className="space-y-5">
        <div className="flex flex-col gap-y-1">
          <label htmlFor="" className="text-sm">
            نام
          </label>
          <Input
            type="text"
            name="name"
            defaultValue={workflow?.name ?? ""}
            placeholder="نام گردش کار"
            required
          />
        </div>
        <div className="flex flex-col gap-y-1">
          <label htmlFor="" className="text-sm">
            توضیحات
          </label>
          <Textarea
            name="description"
            defaultValue={workflow?.description ?? ""}
            placeholder="توضیحات..."
            className="resize-none"
          />
        </div>
        <CategoryMultiSelect
          value={selectedCategoryIds}
          onChange={setSelectedCategoryIds}
          title="دسته بندی های گردش کار"
          description="یک یا چند دسته بندی برای گردش کار انتخاب کنید"
        />
        <Button type="submit" className="w-full" disabled={isPending}>
          {submitBtnText}
        </Button>
      </form>
    </Modal>
  );
};

export default WorkflowModal;
